export default __webpack_public_path__ + "static/media/UsingPointer.fd040959.mp4";